// tech stack icons, used by the Skills section

import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JavaScript from '../assets/javascript.png';
import ReactImg from '../assets/react.png';
import Tailwind from '../assets/tailwind.png';
import Laravel from '../assets/laravel.png';
import PHP from '../assets/php.png';
import Firebase from '../assets/firebase.png';
import Typescript from '../assets/typescript.png';
import Sass from '../assets/sass.png';
import Vue from '../assets/vue.png';
import Mysql from '../assets/mysql.png';
import Vuetify from '../assets/vuetify.png';
import Net from '../assets/net.png';
import Csharp from '../assets/csharp.png';

export const skills = [
  { name: 'JavaScript', image: JavaScript },
  { name: 'React', image: ReactImg },
  { name: 'Vue', image: Vue },
  { name: 'TypeScript', image: Typescript },
  { name: 'C#', image: Csharp },
  { name: '.NET', image: Net },
  { name: 'Laravel', image: Laravel },
  { name: 'PHP', image: PHP },
  { name: 'MySQL', image: Mysql },
  { name: 'Firebase', image: Firebase },
  { name: 'HTML', image: HTML },
  { name: 'CSS', image: CSS },
  { name: 'Tailwind CSS', image: Tailwind },
  { name: 'Sass', image: Sass },
  { name: 'Vuetify', image: Vuetify },
];
